// Exports
export default {
	"background": "background_s256W",
	"video": "video_Pk12s",
	"hidden": "hidden_S962N",
	"mirror": "mirror_zqhr5"
};
